import React from "react";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import trLocale from "date-fns/locale/tr";
import DateFnsUtils from "@date-io/date-fns";
import { FormHelperText } from "@material-ui/core";

export default function Dateonly(props) {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={trLocale}>
      <KeyboardDatePicker
        autoOk
        inputVariant="outlined"
        variant="inline"
        name={props.name}
        label={props.label}
        InputAdornmentProps={{ position: "start" }}
        fullWidth
        value={props.value ? props.value : null}
        onChange={props.onChange}
        margin="normal"
        disablePast
        format="dd.MM.yyyy"
        error={props.error ? true : false}
      />
      {props.error ? (
        <FormHelperText error>{"Boş Olamaz"}</FormHelperText>
      ) : (
        <></>
      )}
    </MuiPickersUtilsProvider>
  );
}
